export const ORDER = {
    ASCENDING: "asc",
    DESCENDING: "desc",
};

export const DEFAULT_ROWS_PER_PAGE = [5, 10, 25, 100];
export const DEFAULT_PAGE_SIZE = 100;
export const DEFAULT_PAGE = 0;
